import { format, parseISO } from 'date-fns';

const DATE_FORMAT = 'MMM-dd-yyyy';
const DATE_TIME_FORMAT = 'MMM-dd-yyyy hh:mm a';
const DATE_TIME_SECONDS_FORMAT = 'MMM-dd-yyyy hh:mm:ss a';
const ISO_DATE_FORMAT = 'yyyy-MM-dd';
const NULL_TIME = 'T00:00:00';

/* To explain the terms in the formula, the Javascript timestamp has milliseconds (*1000) 
which accounts for the 1000. There are 60*60*24 seconds in one day = 86400. Finally, 
Excel dates start on Jan 1 1900, and Javascript starts on Jan 1 1970. 
There are 25567 days between Jan 1 1900 and Jan 1 1970. */
const EXCEL_DAYS_DIFFERENCE = 25568;

const getWeekNumber = (date) => {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

const toString = (date, showTime = false) => {
    if (date !== null) {
        return format(date, showTime ? DATE_TIME_FORMAT : DATE_FORMAT);
    } else {
        return null;
    }
};

const formatDateFromIso = (date, failPlaceholder = 'N/A') => {
    if (!!date && (date || '').length > 0) {
        try {
            var dateFixed = date.toString().trim();

            //Fixing date to have a T instead of a space that are correct in some ISO 8601
            if (!dateFixed.includes('T') && dateFixed.includes(' ')) {
                dateFixed = dateFixed.replace(' ', 'T');
            }

            //All dates should be coming in as UTC (Zulu)
            //   except for those that have the null time which allows us to see dates only irregardless of time zone.
            if (!dateFixed.includes(NULL_TIME) && !dateFixed.includes('Z') && dateFixed.includes('T')) {
                dateFixed += 'Z';
            }

            var parsedIso = parseISO(dateFixed);

            return format(parsedIso, DATE_FORMAT);
        } catch (error) {
            console.error('Got an incorrect date format');

            return failPlaceholder;
        }
    } else {
        return failPlaceholder;
    }
};

const formatDateTimeFromIso = (date, showSeconds = false, failPlaceholder = 'N/A') => {
    if (!!date && (date || '').length > 0) {
        try {
            var dateFixed = date.toString().trim();

            //Fixing date to have a T instead of a space that are correct in some ISO 8601
            if (!dateFixed.includes('T') && dateFixed.includes(' ')) {
                dateFixed = dateFixed.replace(' ', 'T');
            }

            //All dates should be coming in as UTC (Zulu)
            if (!dateFixed.includes('Z') && dateFixed.includes('T')) {
                dateFixed += 'Z';
            }

            var parsedIso = parseISO(dateFixed);

            return format(parsedIso, showSeconds ? DATE_TIME_SECONDS_FORMAT : DATE_TIME_FORMAT);
        } catch (error) {
            console.error('Got an incorrect date format');

            return failPlaceholder;
        }
    } else {
        return failPlaceholder;
    }
};

const DuDateUtilities = {
    ToString: toString,
    ToPrettyDate: (value) => {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return toString(value);
        }

        if (typeof value === 'string') {
            if (value.indexOf('-') === 3) {
                //Pretty Format
                if (value.indexOf(' ')) {
                    //Remove time component
                    return value.split(' ')[0];
                }
                return value;
            }

            if (value.indexOf('-') === 4) {
                //ISO Format
                return formatDateFromIso(value);
            }
        }

        return null;
    },
    ToPrettyDateTime: (value) => {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return toString(value, true);
        }

        if (typeof value === 'string') {
            if (value.indexOf('-') === 3) {
                //Pretty Format
                return value;
            }

            if (value.indexOf('-') === 4) {
                //ISO Format
                return formatDateTimeFromIso(value);
            }
        }

        return null;
    },
    FormatDateFromIso: formatDateFromIso,
    FormatDateTimeFromIso: formatDateTimeFromIso,
    ToIsoDate: function(date, addNullTime = true, failPlaceholder = 'N/A') {
        try {
            var isoDate = format(date, ISO_DATE_FORMAT);

            return isoDate + (addNullTime ? NULL_TIME : '');
        } catch (error) {
            console.error('Got an incorrect date to be able to ISO format');

            return failPlaceholder;
        }
    },
    GetWeekNumber: getWeekNumber,
    GetPoolWeek: function(date) {
        return (
            date
                .getFullYear()
                .toString()
                .substring(2) + ('0' + getWeekNumber(date).toString()).slice(-2)
        );
    },
    TimeSpanToString: function(start, end) {
        var difference = end - start;

        if (difference > 1000) {
            difference /= 1000;

            if (difference > 60) {
                difference /= 60;

                if (difference > 60) {
                    return `${(difference / 60).toFixed(2)} h`;
                }

                return `${difference.toFixed(2)} min`;
            }

            return `${difference.toFixed(2)} s`;
        }

        return `${difference} ms`;
    },
    getDateFromExcelTimeStamp: function(excelDateTimeValue) {
        if (!excelDateTimeValue) {
            return '';
        }

        const jsDateTimeStamp = new Date(Math.round((excelDateTimeValue - EXCEL_DAYS_DIFFERENCE) * 86400 * 1000));
        return this.ToIsoDate(jsDateTimeStamp, '').split('T')[0];
    },
    EXCEL_DAYS_DIFFERENCE
};

export default DuDateUtilities;
